<template>
  <div className="header" id="Header">
    <a href="/">HEM</a>
    <a href="/#about">OM MIG</a>
    <a href="/paintings">TAVLOR</a>
    <a href="/exhibitions">UTSTÄLLNINGAR</a>
    <a href="/courses">KURSER</a>
    <a href="/#contact">KONTAKT</a>
    <a href="/login" v-if="!isAdmin" >LOGIN</a>
    <a href="/" v-if="isAdmin" @click="onLogout">LOGOUT</a>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { logout } from "@/firebase"

export default {
  data() {
    return {
      isAdmin: Cookies.get("user") ? true : false,
    }
  },
  methods: {
    onLogout() {
     logout(); 
    }
  }
};
</script>

<style scoped>
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.header {
  padding: 2em 0em;
  background-color: black;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 20px;
  z-index: 999px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
}
a {
  color: beige;
  margin: 2em;
  text-decoration: none;
  font-weight: 200;
  transition: all .2s ease-in-out;
}

a:hover {
  color:darksalmon;
  transform: scale(2);
}
</style>
